<script setup>
import SInfoPlageHoraire from '@/components/global/s-info-plage-horaire.vue'
import PevisionnelRestauration from '@/components/etablissement/restauration/pevisionnel-restauration.vue'
</script>
<template>
  <div>
    <h3 v-if="loading"><v-progress-circular indeterminate /> Chargement du module de restauration</h3>
    <v-container v-else fluid>
      <v-row>
        <v-col cols="12" md="6" lg="4">
          <h3>Service du midi</h3>
          <s-info-plage-horaire
            :editable="canChangeHoraires"
            titre="Horaires"
            :value="horaires.plageRestaurationMidi"
            @update="handleUpdate"
          />
          <h3>Service du soir</h3>
          <s-info-plage-horaire
            :editable="canChangeHoraires"
            titre="Horaires"
            :value="horaires.plageRestaurationSoir ? horaires.plageRestaurationSoir : undefined"
            @update="handleUpdate"
          ></s-info-plage-horaire>
        </v-col>
        <v-col cols="12" md="6" lg="8">
          <v-chip class="ma-6" v-if="hasNotConfigured">
            <v-icon>mdi-arrow-left</v-icon>Il semblerait que vous n'avez pas configuré d'horaires pour le repas. Faites
            le juste à gauche
          </v-chip>
          <pevisionnel-restauration v-else :etablissement-id="etablissementId" />
        </v-col>
      </v-row>
      <v-row>
        <v-alert class="ma-6" type="info">
          <h4>Module de repas</h4>
          <p>
            Cette page permet de configurer les horaires de repas de l'établissement et d'afficher le d'employé comptés
            comme présent à au repas.
          </p>
          <p>
            Sont comptés comme présent à un repas tout les employés dont le créneau de travail chevauche celui du repas
          </p>
        </v-alert>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'etablissement-detail-restauration',
  props: {
    etablissement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hasNotConfigured: true,
      loading: true,
      horaires: [],
    }
  },
  computed: {
    ...mapGetters({
      isInRole: 'security/isInRole',
    }),
    loaded() {
      return this.etablissement && this.resumeLoaded
    },
    etablissementId() {
      return this.etablissement.etablissementId
    },
    canChangeHoraires() {
      return (
        this.etablissementId !== 0 &&
        this.isInRole('DIRECTEUR_' + this.etablissementId) &&
        this.isInRole('ADMINISTRATEUR_' + this.etablissementId)
      )
    },
  },
  methods: {
    ...mapActions({
      obtenirHorairesDesRepas: 'etablissement/obtenirHorairesDesRepas',
      modifierHorairesDesRepas: 'etablissement/modifierHorairesDesRepas',
    }),
    handleUpdate() {
      this.modifierHorairesDesRepas({
        etablissementId: this.etablissementId,
        debutMidi: this.horaires.plageRestaurationMidi.heureDebut,
        finMidi: this.horaires.plageRestaurationMidi.heureFin,
        debutSoir: this.horaires.plageRestaurationSoir.heureDebut,
        finSoir: this.horaires.plageRestaurationSoir.heureFin,
      })
    },
  },
  mounted() {
    this.obtenirHorairesDesRepas(this.etablissement.etablissementId)
      .then((value) => {
        this.hasNotConfigured = false
        this.loading = false
        this.horaires = value
      })
      .catch(() => {
        this.loading = false
        this.horaires = {
          plageRestaurationMidi: {
            heureDebut: undefined,
            heureFin: undefined,
          },
          plageRestaurationSoir: {
            heureDebut: undefined,
            heureFin: undefined,
          },
        }
      })
  },
}
</script>

<style scoped>
.v-alert {
  background-color: var(--v-primary-lighten2) !important;
}
</style>
